import { Box, CSSReset, Flex, FormLabel, Heading, Switch, ThemeProvider } from '@chakra-ui/core';
import React, { useState } from 'react';
import ConnectChart from './ConnectChart';
// eslint-disable-next-line
import { useFetchConvictionDataSets } from './hooks';

interface ConvictionProps {
  includeComparison?: boolean;
}

const Conviction: React.FC<ConvictionProps> = () => {
  const [quarterly, setQuarterly] = useState(false);
  return (
    <ThemeProvider>
      <CSSReset />
      <Heading ml={{ xs: '0px', md: '133px' }} as="h5" fontFamily="Aeonik" fontSize={{ xs: 'lg', md: 'xl' }}>
        Rendement
      </Heading>
      <Box
        mt={{ xs: '70px', md: '130px' }}
        py={{ xs: '70px', md: '130px' }}
        px={{ xs: '40px', md: '133px' }}
        backgroundColor="#F9F8F7"
      >
        <Flex justify="end" w="full">
          <FormLabel>Per kwartaal</FormLabel>
          <Switch mr={6} size="sm" isChecked={quarterly} onChange={() => setQuarterly(!quarterly)} />
        </Flex>
        <ConnectChart
          startDate={new Date('2024-04-29')}
          useFetchDataSets={useFetchConvictionDataSets({ quarterly })}
          quarterly={quarterly}
        />
      </Box>
    </ThemeProvider>
  );
};

export default Conviction;
